import { Menu } from "lucide-react";
import { BrandMark } from "./BrandMark";
import { LangToggle } from "./LangToggle";
import { ThemeToggle } from "./ThemeToggle";
import { ProfileMenu } from "./ProfileMenu";
import type { RoleConfig } from "./roles";

export function TopBar({ role, onMenu, current }: { role: RoleConfig; onMenu: () => void; current?: string }) {
  return (
    <header className="sticky top-0 z-20 flex h-14 items-center justify-between border-b border-[var(--color-border)] bg-[var(--color-surface)] px-4 sm:px-6">
      <div className="flex min-w-0 items-center gap-2 sm:gap-3">
        <button
          onClick={onMenu}
          className="-ml-1 grid h-9 w-9 place-items-center rounded-lg text-[var(--color-fg-muted)] transition-colors hover:bg-[var(--color-surface-2)] hover:text-[var(--color-fg)] md:hidden"
          aria-label="Меню"
        >
          <Menu size={18} />
        </button>
        <BrandMark to={role.pageBase} />
        <span className="mx-2 hidden text-[var(--color-border-strong)] lg:inline">|</span>
        <nav className="hidden min-w-0 items-center gap-1.5 text-[13.5px] text-[var(--color-fg-muted)] lg:flex">
          <span className="truncate">{role.breadcrumb}</span>
          {current && (
            <>
              <span className="px-1 text-[var(--color-fg-faint)]">/</span>
              <span className="truncate text-[var(--color-fg)]">{current}</span>
            </>
          )}
        </nav>
      </div>
      <div className="flex items-center gap-2 sm:gap-3">
        {role.headerBadge && (
          <span
            className={
              "hidden items-center gap-1.5 rounded-full px-2.5 py-1 text-[11.5px] font-medium sm:flex " +
              (role.headerBadge.tone === "online"
                ? "bg-[var(--color-success-bg)] text-[var(--color-success)]"
                : "bg-[var(--color-danger-bg)] text-[var(--color-danger)]")
            }
          >
            <span
              className="inline-block h-1.5 w-1.5 rounded-full"
              style={{
                background:
                  role.headerBadge.tone === "online"
                    ? "var(--color-success)"
                    : "var(--color-danger)",
              }}
            />
            {role.headerBadge.text}
          </span>
        )}
        <LangToggle />
        <ThemeToggle />
        <span className="hidden h-6 w-px bg-[var(--color-border)] sm:inline" />
        <ProfileMenu current={role} />
      </div>
    </header>
  );
}
